import { Flex, Text } from '@chakra-ui/react'
import { LaborEntryType } from '@hb/shared'
import { useMemo } from 'react'
import { ExistingLaborEntry } from './types'

const entryTypeLabels: Record<LaborEntryType, string> = {
  [LaborEntryType.VITALS]: 'Vitals',
  [LaborEntryType.CERVICAL_EXAM]: 'Cervical Exam',
  [LaborEntryType.FHR]: 'FHR',
  [LaborEntryType.CONTRACTION]: 'Contraction',
  [LaborEntryType.MEDICATION]: 'Medication',
  [LaborEntryType.NARRATIVE]: 'Narrative',
  [LaborEntryType.PROCEDURE]: 'Procedure',
}

export const LaborEntryHeader = ({
  type,
  existingEntry,
}: {
  type: LaborEntryType
  existingEntry: ExistingLaborEntry<LaborEntryType> | null
}) => {
  const startedAtDate = useMemo(
    () => (existingEntry?.entry.startedAt ? new Date(existingEntry.entry.startedAt) : new Date()),
    [existingEntry],
  )
  const dateTimeStr = startedAtDate.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
  return (
    <Flex
      borderBottomWidth={1}
      borderTopWidth={1}
      borderColor="gray.200"
      bg="gray.100"
      _dark={{ bg: 'gray.700', borderColor: 'gray.600' }}
      pb={2}
      px={3}
      pt={2}>
      <Flex gap={2} align="center">
        <Text fontWeight="semibold" fontSize="xl">
          {existingEntry ? 'Amending' : 'New'} {entryTypeLabels[type]}
        </Text>
      </Flex>
      <Text ml="auto" fontSize="xl" opacity={0.7}>
        {dateTimeStr}
      </Text>
    </Flex>
  )
}
